import { AHIcon, AHText, Box } from "arkh";
import { SubscriptionStatus } from "../../subscriptionStatus";

import React from "react";

const statusMessages = {
  [SubscriptionStatus.closed]:
    "Error connecting to server. Make sure that the screen has internet.",
  [SubscriptionStatus.connecting]: "Reconnecting.",
  [SubscriptionStatus.reconnecting]: "Reconnecting.",
};
export function InternetConnectionBar(props: {
  subscriptionStatus: SubscriptionStatus;
}) {
  const status = props.subscriptionStatus;
  if (
    status === SubscriptionStatus.closed ||
    status === SubscriptionStatus.reconnecting
  ) {
    return (
      <Box
        style={[
          {
            position: "absolute",
            left: 0,
            bottom: 0,
            alignItems: "center",
            flexDirection: "row",
          },
        ]}
        spaceLeft="medium"
        spaceBottom="xsmall"
      >
        <Box
          style={{ flexDirection: "row" }}
          spaceHorizontal="large"
          spaceVertical="medium"
          color="surface"
          cornerRadius="small"
        >
          <AHIcon color="negative" spaceRight="small" type="connection-error" />
          <AHText type="title">{statusMessages[status]}</AHText>
        </Box>
      </Box>
    );
  }
  return null;
}
